import TransactionCategoryList from "@/controllers/transaction_category/transaction-category-list.js";


export default {
  extends: TransactionCategoryList,
};
